export default "__VITE_ASSET__5f95b6de__"